<app-container>
    <div class="content-form__wrapper" content>
        <h2>Contacto</h2>
        <ng-container>
            <app-contact-form></app-contact-form>
        </ng-container>
    </div>
</app-container>